import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class RetornoService {
  constructor(
    private http: HttpClient,
  ) { }

  obterRetornos(contaId) {
    return this.http
      .get(urls.apiBase + '/Retornos/ObterTodos?contaId=' + contaId);
  }

  obterPorId(id) {
    return this.http
      .get(urls.apiBase + '/Retornos/ObterPorId?id=' + id);
  }

  enviarRetorno(data, cedenteId) {
    return this.http
      .post(urls.apiBase + '/Retornos/Adicionar?cedenteId=' + cedenteId, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/retorno/retorno.service.ts